import { FC } from "react";

import styles from './styles.module.scss'
import { IconInstagram, IconPresent } from "shared/assets/icons";
import { LEGAL_LINKS } from "shared/config/legal-links";
import { AccessibilityButton } from "shared/ui/accessibility-button";

export const Footer: FC = () => {
    return (
        <div className={styles.footer} id="contacts">
            <div className={styles.__in}>

                <div className={styles.title}>
                    Наши контакты
                </div>

                <div className={styles.main}>

                    <div className={styles.contacts}>

                        <div className={styles.box}>
                            <div className={styles.sub_title}>Грозный</div>
                            <div className={styles.list}>

                                <a href="mailto:ansar@ansarium.ru" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    <div className={`${styles.li}`}>ansar@ansarium.ru</div>
                                </a>
                                <a href="tel:+79953334456" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    <div className={`${styles.li}`}>+7 995 333 4456</div>
                                </a>
                                <a href="https://yandex.ru/maps/?text=Грозный%20ул.%20Сайханова%2029А" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                                    <div className={`${styles.li}`}>г.Грозный ул. Сайханова 29А</div>
                                </a>

                            </div>
                        </div>

                        <div className={`${styles.box} ${styles.tg}`}>
                            <div className={styles.sub_title}>Каналы</div>

                            <div className={styles.list}>

                                <a href="https://t.me/ansarium"><div className={`${styles.li}`}><span>Ansarium</span></div></a>
                                {/* <a href="https://t.me/ansar_live"><div className={`${styles.li}`}><span>Ansar Live</span></div></a>
                                <a href="https://t.me/it_muslims"><div className={`${styles.li}`}><span>IT Muslims</span></div></a>
                                <a href="https://t.me/it_ansar_company"><div className={`${styles.li}`}><span>Ansar</span></div></a> */}

                            </div>
                        </div>

                        <div className={`${styles.box} ${styles.tg}`}>
                            <div className={styles.sub_title}>Мы в соц. сетях</div>

                            <div className={styles.list}>

                                <a href="https://instagram.com/ansar_itcompany">
                                    <div className={`${styles.li} ${styles.insta}`}>
                                        <div className={styles.instagram}>
                                            <div className={styles.icon}>
                                                <IconInstagram width={24} height={24} />
                                            </div>
                                            <div className={styles.name}><span>@ansar_itcompany</span></div>
                                        </div>
                                    </div>
                                </a>

                            </div>
                        </div>

                    </div>

                    <div className={`${styles.box} ${styles.presents}`}>
                        <div className={styles.sub_title}>Материалы</div>

                        <div className={styles.list}>

                            <a href="https://ansarium.ru" target="__blank">
                                <div className={`${styles.li} ${styles.insta}`}>
                                    <div className={styles.instagram}>
                                        <div className={styles.icon}>
                                            <IconPresent width={24} height={24} />
                                        </div>
                                        <div className={styles.name}><span>Ансариум (Платформа)</span></div>
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                    {/* 
                        <div className={styles.box}>
                            <div className={styles.sub_title}>Аккредитация</div>
                            <div className={styles.list}>
                                <div className={styles.li}>Государственная аккредитация Минцифры РФ</div>
                                <div className={styles.li}>Номер решения: АО-20251112-33989584805-3</div>
                                <div className={styles.li}>Дата: 13.11.2025</div>
                                <div className={styles.li}>Реестр №: 76889</div>
                                <div className={styles.li}>ОГРН: 1252000009359</div>
                            </div>
                        </div> */}

                    <div className={styles.logo}>
                        <div className={styles.name}>
                            <span>Ansar</span> 2025
                        </div>
                    </div>

                    <nav className={styles.legalStrip} aria-label="Юридические документы">
                        <a href={LEGAL_LINKS.privacy} target="_blank" rel="noopener noreferrer" className={styles.legalLink}>
                            Политика обработки персональных данных
                        </a>
                        <span className={styles.legalSep} aria-hidden />
                        <a href={LEGAL_LINKS.terms} target="_blank" rel="noopener noreferrer" className={styles.legalLink}>
                            Пользовательское соглашение
                        </a>
                        <span className={styles.legalSep} aria-hidden />
                        <AccessibilityButton />
                    </nav>

                </div>
            </div>
        </div>
    )
}
